export default __webpack_public_path__ + "static/media/loading.30714d6b.svg";